import { BoardContainer } from "./scenes/board-scene/BoardContainer";
import { GameVars } from "./GameVars";
import { GameManager } from "./GameManager";
import { BoardScene } from "./scenes/board-scene/BoardScene";
import * as Colyseus from "colyseus.js";
import { GameConstants } from "./GameConstants";
import { Vector2D } from "carrom-king-engine";
import { isRegExp } from "util";
import { BoardManager } from "./scenes/board-scene/boardManager/BoardManager";

import BattleUtils from "./gzp/BattleUtils";
import { IIsBattleGameInfo } from "./gzp/GzpInterfaces";
export class ColyseusManager {

    public static client: Colyseus.Client;
    public static room: Colyseus.Room;
    public static state: CarromRoomState;
    public static sessionId: string;
    public static roomId: string;
    public static endpoint: string;
    public static restEndpoint: string;
    private static timeout: NodeJS.Timeout;

    public static init(): void {

        window.addEventListener("offline", () => {
            
            if (ColyseusManager.room) {
                ColyseusManager.room.leave(false);
            }
           
        });


        window.addEventListener("beforeunload", this.onCloseTab.bind(this));
        window.addEventListener("unload", this.onCloseTab.bind(this));

        // ws://localhost:4288
        // wss://carrom.gamezop.com
        if (process.env.server === "dev") {
            // ColyseusManager.endpoint = "ws://localhost:4288";
            // ColyseusManager.restEndpoint = "http://localhost:4288";
            ColyseusManager.endpoint = "wss://dev-carrom.gamezop.com";
            ColyseusManager.restEndpoint = "https://dev-carrom.gamezop.com";
        } else {
            ColyseusManager.endpoint = "wss://carrom.gamezop.com";
            ColyseusManager.restEndpoint = "https://carrom.gamezop.com";

            // ColyseusManager.endpoint = "wss://dev-genserver.gamezop.com";
        }

        ColyseusManager.client = new Colyseus.Client(ColyseusManager.endpoint);
        ColyseusManager.room = null;
        ColyseusManager.state = null;
    }

    public static joinRoom(): void {
        let battleMatchId: string;
        let carromRoomName: string = "carrom_casual_room";
        let battleHash: IIsBattleGameInfo = {data: "", hashId: ""};
        if (BattleUtils.isBattle) {
          battleMatchId = BattleUtils.battleInitDetails.matchId;
          carromRoomName = "carrom_room";
          battleHash = BattleUtils.battleGameInfo;
        }
        ColyseusManager.state = {
            friction: GameVars.friction,
            playerA: null,
            playerB: null,
            ready: false,
            mode: GameVars.gameMode,
            currentTurnPlayerId: null,
            timer: 0,
            numShots: 0,
            serverTurnData: null,
            matchId: battleMatchId
        };

        GameVars.playerData.id = BattleUtils.battlePlayerData.gzpId;
        
        let battlePlayersIds: string[] = BattleUtils.battlePlayers.map(player => player.gzpId);

        const options = {
            players: battlePlayersIds,
            friction: GameVars.friction,
            mode: GameVars.gameMode,
            playerInfo: GameVars.playerData,
            missedTurnsToForceGameOver: GameConstants.MISSED_TURNS_GAME_OVER_FORCED,
            matchId: battleMatchId,
            battleHash,
        };

        console.log("JOIN OPTIONS", options)

        ColyseusManager.client.joinOrCreate(carromRoomName, options).then(room => {

            console.log(room.sessionId, "joined", room.name, room.id);
           
            ColyseusManager.room = room;
            ColyseusManager.sessionId = room.sessionId;
            ColyseusManager.roomId = room.id;

            ColyseusManager.setRoomFunctions();

        }).catch(e => {

            console.warn("ERROR ON JOINING ROOM", e);
            setTimeout(function(): void {
                GameManager.onMatchingNotPossible();
            }, GameConstants.DEVELOPMENT ? 250 : 3500); 
        });
    }

    public static leaveRoom(): void {
      clearInterval(ColyseusManager.timeout);
        if (!ColyseusManager.room) {
            return;
        }

        ColyseusManager.room.leave();
        ColyseusManager.room = null;
    }

    public static simulateDisconnection(): void {

        ColyseusManager.room.leave(false);
    }

    public static async tryToReconnect(): Promise<any> {

        try {

            ColyseusManager.room = await ColyseusManager.client.reconnect(ColyseusManager.roomId, ColyseusManager.sessionId);
            ColyseusManager.setRoomFunctions();

            GameVars.connection = true;

            if (GameVars.currentScene.scene.key === "BoardScene") {
                if (GameVars.needSendTurnData) {
                    ColyseusManager.sendMessage("TURN COMPLETED", GameVars.turnData);
                    GameVars.needSendTurnData = false;
                }

                BoardScene.currentInstance.hud.hideDisconnectionMessage();
            }

            clearInterval(ColyseusManager.timeout);
            
        } catch (e) {

            if (e.toString().includes("not found")) {
                if (GameVars.currentScene.scene.key !== "BoardScene") {
                    return;
                }
        
                const boardManager = BoardScene.currentInstance.boardManager;
                boardManager.onGameOver(GameVars.adversaryData.id);

                clearInterval(ColyseusManager.timeout);
            }
        }
    }

    public static setRoomFunctions(): void {

        ColyseusManager.room.onStateChange((state: any) => {

            ColyseusManager.onStateChange(state);
        });

        ColyseusManager.room.onMessage("REPLICATE SHOT", (message: {strikerPosition: {x: number, y: number}, strikerVelocity: {x: number, y: number}, numShots: number}) => {
            

            GameVars.lastShotReplicated = message.numShots;

            const boardManager = BoardScene.currentInstance.boardManager;
            boardManager.replicateShot(message.strikerPosition, message.strikerVelocity);
        });

        ColyseusManager.room.onMessage("CONNECTION REPLICATE SHOT", (message: {numShots: number, client: string, values: {strikerPosition: {x: number, y: number}, strikerVelocity: {x: number, y: number}}}) => {

            if (GameVars.lastShotReplicated !== message.numShots) {
                GameVars.lastShotReplicated = message.numShots;
                const boardManager = BoardScene.currentInstance.boardManager;
                boardManager.replicateShot(message.values.strikerPosition, message.values.strikerVelocity);
            }
        });

        ColyseusManager.room.onMessage("STREAKER POS SPEED DIRECTION", (strikerData: {px: number, r: number, a: number}) => {

            if (GameVars.turnCompleted) {

                BoardContainer.currentInstance.strikerForcedPx = strikerData.px;

                BoardScene.currentInstance.gui.adversaryStrikerSpeedSetter.rAdversary = strikerData.r;
                BoardScene.currentInstance.gui.adversaryStrikerSpeedSetter.angleAdversary = strikerData.a + Math.PI;
            }
        });

        ColyseusManager.room.onMessage("MATCHING NOT POSSIBLE", (message) => {

            GameManager.onMatchingNotPossible();
        });

        ColyseusManager.room.onMessage("ADVERSARY LEFT", (message) => {

            GameManager.onAdversaryLeft();
        });

        ColyseusManager.room.onMessage("EMOJI SELECTED", (emojiId) => {

            BoardScene.currentInstance.showEmoji(emojiId, false);
        });

        ColyseusManager.room.onMessage("PRE TIME OUT", (message) => {

            BoardScene.currentInstance.preTimeOut();
        });

        ColyseusManager.room.onMessage("TIME OUT", (data: {currentTurnPlayerId: string, turnsToForceGameOver: number}) => {

            GameVars.waintingTurn = false;

            const boardManager = BoardScene.currentInstance.boardManager;
            boardManager.onTimeOver(data.currentTurnPlayerId, data.turnsToForceGameOver);
        });

        ColyseusManager.room.onMessage("WAITING FOR ADVERSARY", () => {
            BoardScene.currentInstance.messagesManager.showMessage(Messages.WAITING_FOR_ADVERSARY);
        });

        ColyseusManager.room.onMessage("GAME OVER TIME OUT", (winningPlayerId: string) => {
            BoardScene.currentInstance.boardManager.onGameOver(winningPlayerId, true);
        });
        ColyseusManager.room.onMessage("OPPONENT_COULD_NOT_JOIN", () => {
            BoardScene.currentInstance.messagesManager.showMessage(Messages.WAITING_FOR_OPPONENT);
        });

        ColyseusManager.room.onLeave((code) => {

            if (GameVars.gameOver || GameVars.playingAgainstBot) {
                return;
            }

            console.log("client left the room", code);

            GameVars.connection = false;

            if (GameVars.currentScene.scene.key === "BoardScene") {
                BoardScene.currentInstance.hud.showDisconnectionMessage();
            }

            ColyseusManager.timeout = setInterval(ColyseusManager.tryToReconnect, 1000);
        });
    }

    public static onStateChange(state: CarromRoomState): void {

        const prevState = ColyseusManager.state;
        let boardManager: BoardManager;

        if (GameVars.currentScene.scene.key === "BoardScene") {
            boardManager = BoardScene.currentInstance.boardManager;
        }
        
        if (prevState.playerA === null || prevState.playerB === null) {
            
            if (prevState.playerA === null && state.playerA !== null) {

                ColyseusManager.onPlayerJoined(state.playerA);
            }

            if (prevState.playerB === null && state.playerB !== null) {

                ColyseusManager.onPlayerJoined(state.playerB);
                
                GameVars.reversedBoard = GameVars.playerData.id === state.playerB.id;
            }

            if (state.playerA !== null && state.playerB !== null) {
                
                GameManager.onMatch();
            }
        }

        if (!prevState.ready && state.ready) {
            
            boardManager.onBothPlayersReady(state.currentTurnPlayerId);
        }

        if (prevState.timer !== state.timer) {

            boardManager.onSecondPassed(state.timer);
        }

        if (prevState.numShots !== state.numShots) {

            if (JSON.stringify(state.serverTurnData) !== JSON.stringify(GameVars.turnData)) {
                // console.log("SERVER MISMATCH!!!!!!");
                // console.log("server data");
                // console.log(state.serverTurnData);
                // console.log("client data");
                // console.log(GameVars.turnData);
                // console.log("--------");
                // console.log("--------");
                // console.log("--------");

                for (let i = 0; i < state.serverTurnData.pucks.length; i++) {
                    state.serverTurnData.pucks[i].position = new Vector2D(state.serverTurnData.pucks[i].position.xValue, state.serverTurnData.pucks[i].position.yValue);
                }

                GameVars.turnData = state.serverTurnData;
            } else {

                // console.log("server data");
                // console.log(state.serverTurnData);
                // console.log("client data");
                // console.log(GameVars.turnData);
                // console.log("--------");
                // console.log("--------");
                // console.log("--------");
            }

            boardManager.onValidTurn();
            
        }

        ColyseusManager.state = state;
    }

    public static sendMessage(type: string, message: any): void {

        if (!ColyseusManager.room) {
            return;
        }

        ColyseusManager.room.send(type, message);
    }

    public static onPlayerJoined(playerData: Player): void {

        console.log("ON PLAYER JOINED:", playerData.clientId, " id:", playerData.id);

        if (playerData.id === GameVars.playerData.id) {
            GameVars.playerData.clientId = playerData.clientId;
        } else {
            GameVars.adversaryData = playerData;
        }
    }

    public static onCloseTab(): void {
        this.leaveRoom();
    } 

}
